import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"
import {
  SLIDER_RANGE,
  SLIDER_RANGE_OVERLAY,
  SLIDER_THUMB,
  SLIDER_THUMB_OVERLAY,
  SLIDER_TRACK,
  SLIDER_TRACK_OVERLAY,
} from "./controlStyles"

type SliderProps = React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
  /** `overlay` for controls drawn on a video; `default` everywhere else. */
  variant?: "default" | "overlay"
}

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  SliderProps
>(({ className, variant = "default", ...props }, ref) => {
  const overlay = variant === "overlay"

  return (
    <SliderPrimitive.Root
      ref={ref}
      data-variant={variant}
      className={cn(
        "relative flex w-full touch-none select-none items-center",
        className
      )}
      {...props}
    >
      <SliderPrimitive.Track
        data-testid="slider-track"
        className={overlay ? SLIDER_TRACK_OVERLAY : SLIDER_TRACK}
      >
        <SliderPrimitive.Range className={overlay ? SLIDER_RANGE_OVERLAY : SLIDER_RANGE} />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb
        data-slot="slider-thumb"
        aria-label={props["aria-label"]}
        className={overlay ? SLIDER_THUMB_OVERLAY : SLIDER_THUMB}
      />
    </SliderPrimitive.Root>
  )
})
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
